import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=755e7ba3&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=755e7ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e7ba3",
  null
  
)

export default component.exports